import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft,faUser,faUsers,faBriefcase,faComment,faGlobe,faCalendar,faImage,faCog,faCode,faStar,faSave,faTimes,faMailBulk, faMessage
} from '@fortawesome/free-solid-svg-icons';


const CreateCollaborator = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email:'',
    jobTitle:'',
    photoUrl:null,
    positionJEI:'',
    contactLink:'',
    projectIds:[],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const handleFileChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      setFormData(prev => ({ ...prev, photoUrl: e.target.files[0] }));
    }
  };
const onCancel = () => {
    navigate('/admin/collaborators');
  };
  const handleSubmit = async (e) => {
  const token = localStorage.getItem('token');
    e.preventDefault();
    const data =new FormData();
    data.append('email', formData.email);
    data.append('name', formData.name);
    data.append('positionJEI', formData.positionJEI);
    data.append('jobTitle', formData.jobTitle);
    data.append('contactLink', formData.contactLink);
      
    formData.projectIds.forEach( id => {data.append('projectIds',id)});
      if (formData.photoUrl instanceof File) {
  data.append('photoUrl', formData.photoUrl);
}
    try {

      const res = await axios.post('/collaborator', data, {
        headers: {
  Authorization: `Bearer ${token}`
}

      });

      alert('Collaborateur créé avec succès !');
      navigate('/admin/collaborators');
    } catch (err) {
      console.error("Erreur lors de la création :", err.response?.data || err.message);
      const message = err.response?.data?.message || 'Erreur lors de la création du collaborateur.';
      alert(Array.isArray(message) ? message.join(', ') : message);
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <button className="back-button" onClick={onCancel}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Retour
        </button>
        <h3>Créer un nouveau collaborateur</h3>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="collaborator-form">
          <div className="form-section">
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} className="label-icon" />
                Nom du collaborateur
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Entrez le nom du collaborateur"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMailBulk} className="label-icon" />
                E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Entrez l’e-mail du collaborateur"
                className="form-input"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" />
                Poste / métier (facultatif)
              </label>
              <input
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                placeholder="ingénieur"
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" />
                Rôle au sein de la JEI
              </label>
              <input
                name="positionJEI"
                value={formData.positionJEI}
                onChange={handleChange}
                placeholder="Ex. Président, membre, alumni"
                className="form-input"
                required
              />
            </div> 

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMessage} className="label-icon" />
                Lien de contact (facultatif)
              </label>
              <input
                name="contactLink"
                value={formData.contactLink}
                onChange={handleChange}
                placeholder="Ex. profil LinkedIn ou site personnel"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faImage} className="label-icon" />
                L’image
              </label>
              <input
                type="file"
                name="photoUrl"
                onChange={handleFileChange}
                placeholder="image.jpg"
                className="form-input"
              />
            </div>
             </div>

          <div className="form-actions">
            <button type="submit" className="btn-save">
            <FontAwesomeIcon icon={faSave} />
            Enregistrer
            </button>
            <button type="button" className="cancel-button" onClick={onCancel}>
            <FontAwesomeIcon icon={faArrowLeft} />
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCollaborator;
